module.exports = "/client/static/images/browser-safari.c9539aaf.svg";